import { z } from 'zod'

export const OperatorParser = z.object({
  id: z.number(),
  name: z.string(),
  logoUrl: z.string().nullable(),
  mainContactName: z.string().nullable(),
  mainContactTel: z.string().nullable(),
  mainContactEmail: z.string().nullable(),
  maxTraders: z.number(),
  createdAt: z.string(),
  notificationEmails: z.string().nullable(),
  pricePerGB: z.number(),
  isPush: z.boolean(),
  mailingEmails: z.string().nullable(),
  licenseLimitEmails: z.string().nullable(),
  group: z.string()
})

export const OperatorRequestResponseParser = z.object({
  data: z.union([
    z.object({
      content: z.array(OperatorParser).or(OperatorParser)
    }),
    OperatorParser
  ])
})

export const OpsConsoleOperatorRequestResponseParser = z.object({
  content: z.array(OperatorParser).or(OperatorParser)
})

export type GetOperatorsProps = {
  token: string
  countUsers?: boolean
  operatorUrl?: string
}
export type GetOperatorProps = {
  operatorId: number | string
  token: string
}

export type DGEOperator = z.infer<typeof OperatorParser>
export type OperatorWithUsersCount = DGEOperator & {
  usersCount: number
}

export const CreateOperatorParser = z.object({ data: OperatorParser, token: z.string() })

export const CreateOperatorResponseParser = z.object({ data: OperatorParser })

export type CreateDGEOperator = z.infer<typeof CreateOperatorParser>

export type CreateDDEOperatorResponse = z.infer<typeof CreateOperatorResponseParser>

export type CreateDDEOperatorData = z.infer<typeof CreateOperatorParser>

export type CreateDDEOperator = {
  token: string
  data: CreateDDEOperatorData
}
